import '../scss/main.scss';
import WebFont from 'webfontloader';
import Phaser from 'phaser';
import './core/mixins/mixins';
import { app } from './core/App';
import { scenes } from './rooting';

WebFont.load({
  classes: false,
  custom: {
    families: ['ARCO', 'FREDFREDBURGERARAHEADBLACK', 'FREDFREDBURGERHEADLINE-BLACK']
  },
  active: () => {
    // Would be nice to tie this into the preloader to guarantee all fonts are loaded.
    console.log('All fonts loaded');
  }
});

window.addEventListener('load', function () {
  const game = new Phaser.Game({
    ...app.gameConfig,
    // width: 800,
    // height: 600,
    // backgroundColor: '#2f2f2f',
    // scale: {a
    //   mode: Phaser.Scale.ScaleModes.FIT,
    //   autoCenter: Phaser.Scale.Center.CENTER_BOTH
    // },
    physics: {
      default: 'matter',
      matter: {
        debug: false, //!__IS_PRODUCTION__,
        enabled: true,
        gravity: true
      }
    },
    fps: {
      target: 30
    },
    scene: scenes
  });

  app.afterGame(game, () => {
    game.scene.start(app.config.bootScene);
  });
});
